import { useEffect, useState } from 'react';
const colors = ['#E06621', '#DA3A87', '#326AC2', '#1589BB', '#BB8A1A', '#268B1D', '#D34949', '#B235C6', '#03825C', '#743AEF'];
export function useSubGroupColors({
  teams
}) {
  const [teamsColors, setTeamsColors] = useState();
  useEffect(() => {
    if (teams) getTeamsColors(teams);
    return () => setTeamsColors(undefined);
  }, [teams]);
  function getTeamsColors(teams) {
    setTeamsColors(teams.reduce((res, {
      id
    }) => {
      res[id] = colors[id % 10];
      return res;
    }, {}));
  }
  return {
    teamsColors
  };
}